import { useMutation } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { PlayerDeviceSettings } from '@/types/dtos/player/response/player.dto';

export type UpdatePlayerDeviceSettingsBody = Partial<PlayerDeviceSettings> & {
  testAudioOutput?: true;
};

export type UpdatePlayerDeviceSettingsParams = {
  playerId: string;
  body: UpdatePlayerDeviceSettingsBody;
};

export const useUpdatePlayerDeviceSettingsMutation = () => {
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async (params: UpdatePlayerDeviceSettingsParams) => {
      const token = await getToken();
      return updatePlayerDeviceSettings(params, token ?? '');
    },
  });
};

const updatePlayerDeviceSettings = async (params: UpdatePlayerDeviceSettingsParams, token: string): Promise<void> => {
  const url = `${import.meta.env.VITE_API_URL}/player/${params.playerId}/device-settings`;
  await sendJSONRequest({
    url,
    method: METHOD.POST,
    body: params.body,
    token,
  });
};
